import React, { useState } from 'react';
import { Form } from '@availity/form';
import { DateRangeField } from '@availity/date';
import { Container, Row, CardProps, Col, ListGroup, Spinner } from 'reactstrap';
import { SelectField } from '@availity/select';
import { useQuery } from '@apollo/react-hooks';
import { vendorDashboardQuery } from '@/graphql/queries';
import { FaCalendarMinus } from 'react-icons/fa';
import moment from 'moment';
import { dateRange } from '@availity/yup';
import { LeadsShowExportModal } from '@/modals';
import { useNetwork } from '@/hooks';
import VendorItem from './VendorItem';
import DashboardItem from './DashboardItem';

const Dashboard: React.SFC = () => (
  <Container fluid>
    <Form
      initialValues={{
        vendor: undefined,
        leadType: 'vendor',
        dateRange: {
          startDate: moment({ hour: 0 }),
          dateRange: dateRange({}),
          endDate: moment({ hour: 23 }),
        },
      }}
      onSubmit={() => {}}
    >
      {({ values }) => {
        const created = {
          gte: values.dateRange.startDate,
          lte: values.dateRange.endDate,
        };

        const [showExportModal, setShowExportModal] = useState(false);
        const { network } = useNetwork();

        const { data, loading } = useQuery(vendorDashboardQuery, {
          pollInterval: 300000,
          fetchPolicy: 'network-only',
          variables: {
            filter: {
              networkID: network?.networkID,
              key: 'vendorName.keyword',
              created,
              includeTotal: true,
              leadType: values.leadType,
            },
          },
          skip: !values.dateRange.startDate || !values.dateRange.endDate,
        });

        const vendors = data?.dashboards?.vendors.items || [];
        const total = data?.dashboards?.vendors.total;

        return (
          <>
            <Row className="mt-5">
              <Col xs={4} sm={3} className="d-flex align-items-center">
                <h2 className="mb-0 d-flex align-items-end h1">
                  Vendor Totals
                </h2>
                {loading && (
                  <Spinner
                    className="ml-3"
                    color="primary"
                    style={{
                      width: 50,
                      height: 50,
                    }}
                  />
                )}
              </Col>
              <Col xs={1}>
                <SelectField
                  name="leadType"
                  label="Lead Type"
                  options={[
                    {
                      label: 'Vendor',
                      value: 'vendor',
                    },
                    {
                      label: 'Recycled',
                      value: 'recycled',
                    },
                    // {
                    //   label: 'Live Transfer',
                    //   value: 'liveTransfer',
                    // },
                  ]}
                />
              </Col>
              <Col
                xs={6}
                sm={{
                  size: 6,
                  offset: 1,
                }}
              >
                <DateRangeField
                  className="leads-date-range"
                  name="dateRange"
                  id="dateRange"
                  label="Date Range"
                  customArrowIcon="-"
                  calendarIcon={
                    <div>
                      <FaCalendarMinus />
                    </div>
                  }
                  datepickerProps={{
                    renderMonthElement: undefined,
                  }}
                  ranges
                />
              </Col>
            </Row>
            <div className="text-muted mb-3 d-flex justify-content-end">
              Costs are weighted averages and does not include processing fees.
            </div>
            <ListGroup>
              {total && (
                <DashboardItem
                  className="bg-transparent mb-3 border-0"
                  {...total}
                  displayName="Totals"
                />
              )}
              {vendors.map((v) => (
                <VendorItem
                  key={v.name}
                  openExportsModal={() => setShowExportModal(true)}
                  className="mb-3 border-top border-secondary"
                  leadType={values.leadType}
                  created={{
                    gte: values.dateRange.startDate,
                    lte: values.dateRange.endDate,
                  }}
                  {...v}
                />
              ))}
              {vendors.length === 0 && !loading && (
                <h4 className="text-center mt-3">No Data For Given Range</h4>
              )}
            </ListGroup>
            <LeadsShowExportModal
              isOpen={showExportModal}
              toggle={() => setShowExportModal((o) => !o)}
            />
          </>
        );
      }}
    </Form>
  </Container>
);

export default Dashboard;
